import validate from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/pages/runtime/validate.js";
import v3_45session_45global from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/middleware/v3-session.global.ts";
import manifest_45route_45rule from "/Users/niceloop/Desktop/Niceloop/nuxt3-mobile-order/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  v3_45session_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}